import { ReactNode, createContext } from "react";
import { useState, useEffect } from "react";
import { ENFORCE_STOCK_IDS } from "@constants/defaults";
import log from "loglevel";
import localforage from "localforage";

const ENFORCE = "enforce_stockIDs";

const EnforceStockIDsContext = createContext({
	enforce: false,
	setEnforce: (enforce: boolean) => {},
});

type EnforceStockIDsContextProps = {
  children?: ReactNode
};

export const EnforceStockIDsProvider = ({ children }: EnforceStockIDsContextProps) => {

  const [enforce, setEnforce] = useState<boolean>(ENFORCE_STOCK_IDS);

  useEffect(() => {

    localforage.getItem<boolean>(ENFORCE)
    .then((value: boolean | null) => {
      if (value !== null) {
        console.log("Retrieved enforce IDs:", value);
        setEnforce(value);
      } else {
        console.log("No value found");
      }
    })
    .catch((err: unknown) => {
      console.error("Error retrieving from storage", err);
    });
    /*
    Cache.getItem(ENFORCE)
    .then(result => {
      if(result) {
        setEnforce(result);
      }
    })*/
    return () => {
    };
  }, []);   

  useEffect(() => {

    //Cache.setItem(ENFORCE, enforce);
    localforage.setItem(ENFORCE, enforce).then(function () {
      log.debug("Stored enforce IDs")
    }).catch(function (err) {
      log.error(err);
    });
    return () => {
    };
  }, [enforce]);   

  return (
    <EnforceStockIDsContext.Provider value={{enforce, setEnforce}}>
      {children}
    </EnforceStockIDsContext.Provider>
  );
};


export default EnforceStockIDsContext;

